import { useNavigate, useParams } from "react-router";
import { CourseDetailView } from "@/features/courses/components/CourseDetailView";
import { useGetReservationContext } from "@/features/shops/api/useGetReservationContext";
import { isValidId } from "@/lib/id";

export default function CourseDetailPage() {
  const {
    caseToken = "",
    shopId = "",
    productId = "",
  } = useParams<{ caseToken: string; shopId: string; productId: string }>();
  const navigate = useNavigate();
  // 案件の予約希望日時・人数を利用日時と人数選択のデフォルト値に使う。useGetReservationContext は
  // features/shops の hook のため、feature 間 import を避けて app 層で呼び props で渡す (ADR-009)。
  // URL の ID が不正な場合はクエリを無効化し、NotFound 表示のままシードも走らせない
  // (props が空文字になり CourseDetailView 側の effect は何もしない)。
  const reservationContextQuery = useGetReservationContext(
    caseToken,
    Boolean(caseToken) && isValidId(shopId) && isValidId(productId),
  );

  return (
    <CourseDetailView
      caseToken={caseToken}
      shopId={shopId}
      productId={productId}
      preferredDate={reservationContextQuery.data?.preferredDate ?? ""}
      preferredTime={reservationContextQuery.data?.preferredTime ?? ""}
      preferredPartySize={reservationContextQuery.data?.preferredPartySize ?? ""}
      onReserve={() => navigate(`/${caseToken}/${shopId}/${productId}/checkout`)}
      onBackToShop={() => navigate(`/${caseToken}/${shopId}`)}
    />
  );
}
